<template>
    <div class="flex gap-2 items-stretch pb-1" :style="{ height: rowHeight }">
        <div class="shrink-0 w-12 pt-1 text-right">
            <div
                class="text-sm font-semibold leading-tight"
                :class="cell.kind === SLOT_PAST ? 'text-gray-600' : 'text-gray-800'"
            >
                {{ hourNumber }}
            </div>
            <div class="text-xs font-semibold tracking-wide text-gray-600">{{ meridiem }}</div>
        </div>

        <div class="grow">
            <SlotBlock
                :cell="cell"
                :price-hint="priceHint"
                @book="$emit('book', $event)"
                @view-event="$emit('viewEvent', $event)"
            />
        </div>
    </div>
</template>

<script setup>
    import { computed } from "vue";
    import SlotBlock from "./SlotBlock.vue";
    import { SLOT_PAST } from "../../Composables/useBookingSchedule.js";

    // The list's geometry: an hour gutter, and a block sized to however many hours it covers.
    // What the block says is SlotBlock's business, and the grid asks it the same question.
    const props = defineProps({
        cell: Object,
        /** Row height in px for a single hour; multi-hour blocks are a multiple of it. */
        hourHeight: {
            type: Number,
            default: 60,
        },
        priceHint: String,
    });

    defineEmits(["book", "viewEvent"]);

    // Each row carries its own 4px gap, so a block spanning N hours reclaims the gaps it covers.
    const rowHeight = computed(() => `${props.cell.length * props.hourHeight - 4}px`);

    const hourNumber = computed(() => props.cell.hour % 12 || 12);
    const meridiem = computed(() => (props.cell.hour >= 12 ? "PM" : "AM"));
</script>
